import { reduceMotion } from './env';

/*
  Vidéos de fond (video[data-bg-video]) : lecture seulement lorsqu'elles sont
  visibles, et jamais pour les personnes qui limitent les animations.
*/
export function initBackgroundVideos() {
  const videos = [...document.querySelectorAll<HTMLVideoElement>('video[data-bg-video]')];
  if (!videos.length) return;

  if (reduceMotion) {
    for (const video of videos) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const video = entry.target as HTMLVideoElement;
      if (entry.isIntersecting) {
        video.play().catch(() => {
          // lecture refusée (économie d'énergie…) : la première image reste affichée
        });
      } else {
        video.pause();
      }
    }
  });
  for (const video of videos) observer.observe(video);
}
